import { take } from "redux-saga/effects"
import { REQUEST_ERROR } from "src/engine/modules/session/actions/types"
import { messageTypes } from "../constants"

export default function* fromSession() {
  const reaction = yield take([REQUEST_ERROR])

  const { error } = reaction

  const data = error.data || {}
  const message = data.exception || error.message

  if (error.response) {
    switch (error.response.status) {
      case 400:
        if (data.errorCode !== `application.request.validation.failed`) {
          return [message, messageTypes.error, null, data.status]
        }
        break
      case 401:
      case 404:
        return null
      default: {
        const data = error.data || {}
        const message = data.exception || error.message
        return [message, messageTypes.error, null, data.status]
      }
    }
  }
  return null
}
